import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import { accessNested } from 'utils/utils';
import Socials from 'components/bolt/socials/socials';
import { getDynamicData } from 'utils/bolt/dynamicData';
import { getIsSinglePageIframed } from 'utils/bolt/client';

import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {
	async componentDidMount() {
		await this.loadCustomData(await getDynamicData('landing'));
	}

	async loadCustomData(dynamicData) {
		if (!dynamicData) {
			return;
		}

		this.dynamicData = {
			socials: (dynamicData?.header?.socials || []).reduce((acc, sItem, index) => {
				acc[sItem.icon] = { destination: sItem.path, order: index };
				return acc;
			}, {}),
		};
		this.forceUpdate();
	}

	shouldHideActionBtn(actionData, showtimes, homeEnt, pressKit) {
		// const interstitialOpen = this.props.headerData?.interstitialOpen;
		// if (actionData.hidden) return true;
		if (actionData.icon === 'back') return false;
		const isSinglePageIframed = getIsSinglePageIframed();
		if ((homeEnt || showtimes || pressKit) && isSinglePageIframed) return true;
	}

	hasFilmPage() {
		const pages = Object.values(this.props.appData.pages || {}).filter(
			(page) => page && page.id && page.base === 'bolt'
		);
		return pages.some((page) => page.type === 'filmPage');
	}

	renderSocial() {
		const socials = this.props.appData?.header?.powsterHeader?.follow;
		if (!socials) {
			return null;
		}
		return (
			<Socials
				class={s.socials}
				socials={socials}
				navOpen={this.props.navOpen}
				key="socials"
			/>
		);
	}

	render(props) {
		const baseJSX = super.render(props);
		const headerContainer = baseJSX.children[1];
		const showtimesVisible = accessNested(this.props, 'headerData.showtimesOverlay', false);
		const homeEntVisible = accessNested(this.props, 'headerData.homeEntOverlay', false);

		if (this.hasFilmPage() && showtimesVisible || homeEntVisible) {
			headerContainer.attributes.class += ` ${s.filmPageShowtimes}`;
		}
		const extraSocials = this.renderSocial();
		if (extraSocials) {
			headerContainer.children.push(extraSocials);
		}
		return baseJSX;
	}

}